import React, { useRef, useState } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EventIcon from "@mui/icons-material/Event";
import {
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import "react-datepicker/dist/react-datepicker.css";

// import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";

import {
  getAdvancePaymentReportXlsx,
  getMonthlyDetails,
  getOverallCounterDetail,
} from "./reportsApi";
// import GstReportCard from "./gstReportCard";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import dayjs from "dayjs";
import CounterSalesItemCard from "./counterItemCard";
import axios from "../../../utils/axios";
import {
  getEndOfMonth,
  getFirstDateOfCurrentMonthPayloadFormate,
  getFirstDateOfMonth,
  getLastDateOfCurrentMonthPayloadFormat,
  getStartOfMonth,
  payloadDateFormat,
} from "../../../utils/commonUtils";
import EmployeeModal from "../../../common/employeeModel";
import { useNavigate } from "react-router";
import Heading from "../../../common/Heading";

const EmployeeAdvanceReport = () => {
  const [open, setOpen] = useState(false);

  const [employeeList, setEmployeeList] = useState([]);

  const [formData, setFormData] = useState({});
  const [employeeDetail, setEmployeeDetail] = useState(null);
  function addLeadingZero(value) {
    return value < 10 ? "0" + value : value;
  }

  const [openT, setOpenT] = useState(false);

  const displayDateFormat = () => {
    var currentDate = new Date();
    let dateContainer = String(currentDate).split(" ");

    var year = dateContainer[2];
    var month = dateContainer[1];

    var day = dateContainer[3];

    var formattedDate =
      year + "-" + addLeadingZero(month) + "-" + addLeadingZero(day);

    return formattedDate;
  };
  const [gstReports, setgstReports] = useState({
    totalSales: "",
    gstReports: [],
  });
  const [counterSales, setCounterSales] = useState();
  const [billFilter, setBillFilter] = useState("cash");

  const [date, setDate] = useState(null);
  const [displayEndDate, setDisplayEndDate] = useState(null);
  const [dateFocused, setDateFocused] = useState(false);
  // const today = dayjs();
  // .....
  // const [startDateFormat, setstartDateFormat] = useState(
  //   dayjs(getFirstDateOfMonth()).format("YYYY-MM-DD")
  // );
  // const [endDate, setEndDate] = useState(
  //   dayjs(getEndOfMonth()).format("YYYY-MM-DD")
  // );
  // .........
  // const [endDate, setEndDate] = useState();
  //  const [startDateFormat, setstartDateFormat] = useState(
  //    today.format("YYYY-MM-DD")
  //  );
  //  const [endDate, setEndDate] = useState(today.format("YYYY-MM-DD"));
  // // ..
  //   const [SelectedStartDate, setSelectedStartDate] = useState(null);
  //   const [SelectedEndDate, setSelectedEndDate] = useState(null);
  // ..............
  // const [SelectedStartDate, setSelectedStartDate] = useState(
  //   dayjs(getFirstDateOfMonth())
  // );
  // const [SelectedEndDate, setSelectedEndDate] = useState(
  //   dayjs(getEndOfMonth())
  // );
  // const [SelectedStartDate, setSelectedStartDate] = useState(today);
  // const [SelectedEndDate, setSelectedEndDate] = useState(today);

  // const [startDateOpen, setStartDateOpen] = useState(false);
  // const [endDateOpen, setEndDateOpen] = useState(false);

  const [SelectedStartDate, setSelectedStartDate] = useState(
    dayjs(getFirstDateOfMonth())
  );
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [startDateFormat, setstartDateFormat] = useState(
    dayjs(getFirstDateOfMonth()).format("YYYY-MM-DD")
  );

  const datePickerRef = useRef();
  const datePickerRef2 = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const getData = async (param) => {
    await getOverallCounterDetail(param)
      .then((res) => {
        setCounterSales(res?.data?.data);
      })
      .catch((err) => {
        console.log("err ", err);
      });
  };
  // const datePickerOnChange = (newValue) => {
  //   setSelectedStartDate(newValue);

  //   const dateStr2 = newValue.toDate
  //     ? newValue.toDate().toLocaleDateString("en-GB", {
  //         year: "numeric",
  //         month: "long",
  //         day: "2-digit",
  //       })
  //     : newValue.format("DD-MMMM-YYYY");
  //   let dateContainer = String(dateStr2).split(" ");
  //   var year2 = dateContainer[2];
  //   var month2 = dateContainer[1];
  //   var day2 = dateContainer[0];
  //   var formattedDate2 = day2 + "-" + month2 + "-" + year2;
  //   setDate(formattedDate2);

  //   // Update startDateFormat for API call
  //   setstartDateFormat(newValue.format("YYYY-MM-DD"));
  //   setStartDateOpen(false);
  //   setEndDateOpen(true);
  // };
  // const datePickerOnChangeEnd = (newValue) => {
  //   setSelectedEndDate(newValue);

  //   const dateStr2 = newValue.toDate
  //     ? newValue.toDate().toLocaleDateString("en-GB", {
  //         year: "numeric",
  //         month: "long",
  //         day: "2-digit",
  //       })
  //     : newValue.format("DD-MMMM-YYYY");
  //   let dateContainer = String(dateStr2).split(" ");
  //   var year2 = dateContainer[2];
  //   var month2 = dateContainer[1];
  //   var day2 = dateContainer[0];
  //   var formattedDate2 = day2 + "-" + month2 + "-" + year2;
  //   setDisplayEndDate(formattedDate2);

  //   // Update endDate for API call
  //   setEndDate(newValue.format("YYYY-MM-DD"));
  //   setEndDateOpen(false);
  // };

  useEffect(() => {
    console.log("start date ", startDateFormat);
    // console.log("display End ", endDate);
    // getData({
    //   pageSize: 200,
    //   page: 1,
    //   fromDate: startDateFormat,
    //   toDate: endDate,
    //   employeeId: employeeDetail?.id,
    // });
    getData({
      pageSize: 200,
      page: 1,
      fromDate: startDateFormat,
      toDate: dayjs(startDateFormat).endOf("month").format("YYYY-MM-DD"),
      employeeId: employeeDetail?.id,
    });
  }, [startDateFormat]);

  useEffect(() => {
    console.log("datE ", payloadDateFormat());
    // getData({
    //   pageSize: 200,
    //   page: 1,
    //   fromDate: startDateFormat,
    //   toDate: endDate,
    //   employeeId: employeeDetail?.id,
    // });
    getData({
      pageSize: 200,
      page: 1,
      fromDate: startDateFormat,
      toDate: dayjs(startDateFormat).endOf("month").format("YYYY-MM-DD"),
      employeeId: employeeDetail?.id,
    });
  }, [openT]);

  const downloadXLSXFile = async (param) => {
    try {
      const response = await getAdvancePaymentReportXlsx(param, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = URL.createObjectURL(blob);

      // Optional: create filename using fromDate (only month/year)
      const selectedMonth = dayjs(param.fromDate).format("MMM-YYYY");
      const filename = `Advance_Payment_Report_${selectedMonth}.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url); // Clean up memory
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
      alert("Failed to download report. Please try again.");
    }
  };

  return (
    <>
      <Box
        px={4}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Heading name="Employee Advance Payment Report" />

        <Grid container spacing={1} sx={{}}>
          <Grid
            item
            xs={12}
            sm={5}
            sx={{
              fontWeight: "bold",
              mt: { xs: "1px", sm: "0px" },
            }}
          >
            <TextField
              fullWidth
              id="Value"
              label="Employee Name"
              size="small"
              sx={{
                backgroundColor: "white",
                borderRadius: 1,
                border: "none",
                "& fieldset": { border: "none" },
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
              value={employeeDetail?.name}
              onChange={(e) => {}}
              InputProps={{
                endAdornment: (
                  <SearchIcon
                    onClick={() => {
                      setOpenT(true);
                    }}
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                      cursor: "pointer",
                    }}
                  />
                ),
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                },
              }}
              InputLabelProps={{
                shrink: !!employeeDetail?.name,
                sx: {
                  fontWeight: 500,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                },
              }}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={5}
            sx={{
              fontWeight: "bold",
              mt: { xs: "1px", sm: "0px" },
            }}
          >
            <TextField
              label="Month"
              size="small"
              value={
                SelectedStartDate
                  ? `${dayjs(SelectedStartDate).format("MMM-YYYY")}`
                  : ""
              }
              id="datepickerfield"
              placeholder="Select month"
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" }, // ✅ input value font size
                },
                readOnly: true,
                endAdornment: (
                  <CalendarMonthIcon
                    sx={{
                      cursor: "pointer",
                      mr: 1,
                    }}
                    onClick={() => setStartDateOpen(true)}
                  />
                ),
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" }, // ✅ input value font size
                  background: "#fff",
                  borderRadius: 1,
                  cursor: "pointer",
                  fontFamily: "'Montserrat', sans-serif",
                  fontWeight: 500,
                  "& fieldset": { border: "none" },
                },
              }}
              onClick={() => setStartDateOpen(true)}
              sx={{ width: "100%", height: "50px" }}
              InputLabelProps={{
                sx: {
                  fontWeight: 500,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                },
              }}
            />

            <Box sx={{ position: "relative" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={startDateOpen}
                  onClose={() => setStartDateOpen(false)}
                  value={SelectedStartDate}
                  onChange={(val) => {
                    setSelectedStartDate(val);
                    setstartDateFormat(val.format("YYYY-MM-DD"));
                    setStartDateOpen(false);
                  }}
                  views={["month", "year"]}
                  openTo="month"
                  format="MM-YYYY"
                  defaultValue={dayjs(getFirstDateOfMonth())}
                  onOpen={() => {
                    if (!SelectedStartDate) {
                      const firstOfMonth = dayjs(getFirstDateOfMonth());
                      setSelectedStartDate(firstOfMonth);
                      setstartDateFormat(firstOfMonth.format("YYYY-MM-DD"));
                    }
                    setStartDateOpen(true);
                  }}
                  slotProps={{
                    popper: {
                      placement: "bottom-start",
                      anchorEl: document.querySelector("#datepickerfield"),
                      sx: { zIndex: 1500 },
                    },
                    textField: { style: { display: "none" } },
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              // size="medium"
              fullWidth
              onClick={() => {
                const fromDate = dayjs(SelectedStartDate)
                  .startOf("month")
                  .format("YYYY-MM-DD");
                const toDate = dayjs(SelectedStartDate)
                  .endOf("month")
                  .format("YYYY-MM-DD");

                downloadXLSXFile({
                  pageSize: 200,
                  page: 1,
                  fromDate,
                  toDate,
                  employeeId: employeeDetail?.id,
                });
              }}
              sx={{
                height: "40px",
                backgroundColor: "#14008B",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
              endIcon={<FileDownloadIcon />}
            >
              Download
            </Button>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sm={3}
          sx={{
            padding: "8px 16px",
            margin: "8px 8px 0px 0",
            fontWeight: "500",
            backgroundColor: "#CCCCFF",
            borderRadius: "8px",
          }}
        >
          <Typography
            component="p"
            sx={{
              display: "flex",
              alignItems: "center",
              marginLeft: "5px",
              color: "#00008B",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Total Amount(₹) :&nbsp;&nbsp;
            </Typography>
            <Typography
              component="span"
              sx={{
                fontWeight: "bold",
                marginLeft: "8px",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              {counterSales?.totalAmount?.toFixed(2)}
            </Typography>
          </Typography>
        </Grid>

        <Grid
          container
          sx={{ p: "10px", mt: 2, background: "white", borderRadius: "20px" }}
        >
          <Grid item xs={12} sx={{ padding: "10px" }}>
            <Grid
              container
              sx={{ borderBottom: "1.5px solid black", paddingBottom: "5px" }}
            >
              <Grid item xs={0} sm={1}></Grid>
              <Grid item xs={4} sm={3}>
                <Typography
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // overflow: "Hidden",
                    // display: "-webkit-box",
                    // "-webkit-line-clamp": "1",
                    // "-webkit-box-orient": "vertical",
                    // fontFamily: "'Montserrat', sans-serif",
                    px: { xs: "2px", sm: "22px" },
                    color: "#01008B",
                    marginLeft: { sm: "30px", xs: "0px" },
                    fontWeight: 500,
                    textAlign: "center",
                  }}
                >
                  Date
                </Typography>
              </Grid>

              <Grid item xs={4}>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // overflow: "Hidden",
                    // display: "-webkit-box",
                    // "-webkit-line-clamp": "1",
                    // "-webkit-box-orient": "vertical",
                    // fontFamily: "'Montserrat', sans-serif",
                    px: { sm: "22px", xs: "0px" },
                    color: "#01008B",
                    marginLeft: { sm: "30px", xs: "0px" },
                    fontWeight: 500,
                  }}
                >
                  Employee Name
                </Typography>
              </Grid>

              <Grid
                item
                xs={4}
                sm={3}
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // overflow: "Hidden",
                  // textOverflow: "ellipsis",
                  // display: "-webkit-box",
                  // "-webkit-line-clamp": "1",
                  // "-webkit-box-orient": "vertical",
                  textAlign: "center",
                  fontWeight: 500,
                  color: "#01008B",
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                Amount
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ height: "60vh", overflow: "auto", marginTop: "10px" }}
          >
            {counterSales?.records?.map((item, i) => {
              return (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  // lg={6}
                  key={"payamentRecpt" + i}
                  sx={{ p: "0px" }}
                >
                  <CounterSalesItemCard item={item} />
                </Grid>
              );
            })}
          </Grid>
          <EmployeeModal
            open={openT}
            setOpen={setOpenT}
            callback={(data) => {
              setOpenT(false);
              setEmployeeDetail(data);
              setFormData((prev) => {
                let temp = { ...prev };
                temp.employeeId = data?.id;
                console.log("employee detail", data);
                return temp;
              });
              console.log(data, "callback ");
            }}
            onClose={() => {
              setOpenT(false);
            }}
            employeeList={employeeList}
          />
        </Grid>
      </Box>
    </>
  );
};

export default EmployeeAdvanceReport;
